import FormattedMessage from 'I18n/components/FormattedMessage';
import { SortTableDescIcon } from 'foundations-assets/icons/components/SortTableDescIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { useScopedTranslations } from 'pricing-pages-ui-components/i18n/useScopedTranslations';
import { useContext } from 'react';
import { PublicI18nContext } from '../context/I18nContext';
import comparePlansTranslations from 'i2l?query=sporks!../../lang/compare-plans-link/en.lyaml';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function scrollToFeatureTable() {
  const element = document.querySelector('#feature-table');
  const fallback = document.querySelector('table');
  const targetElement = element || fallback;
  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: 'smooth'
    });
  }
}
export const PublicComparePlansLink = ({
  onClick
}) => {
  const {
    i18nLoader
  } = useContext(PublicI18nContext);
  const T = useScopedTranslations(comparePlansTranslations, i18nLoader);
  const handleClick = e => {
    e.preventDefault();
    scrollToFeatureTable();
    onClick === null || onClick === void 0 || onClick();
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    marginBlockStart: "500",
    children: [/*#__PURE__*/_jsx(T.Skeleton, {
      widths: ['280px'],
      heights: [16],
      children: /*#__PURE__*/_jsx(Link, {
        href: "#feature-table",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.comparePlansLink"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(SortTableDescIcon, {
        size: "600",
        color: "text-interactive-default"
      })
    })]
  });
};